module.exports = __webpack_public_path__ + "static/media/recoveryRegistrationStep.62a53a52.md";